import React from 'react';

import AuthUserContext from './context';
import { withFirebase } from '../Firebase';

const needsEmailVerification = (authUser) =>
  authUser &&
  !authUser.emailVerified &&
  authUser.providerData
    .map((provider) => provider.providerId)
    .includes('password');

const withEmailVerification = (Component) => {
  class WithEmailVerification extends React.Component {
    constructor(props) {
      super(props);

      this.state = { isSent: false };
    }

    onSendEmailVerification = () => {
      this.props.firebase
        .doSendEmailVerification()
        .then(() => this.setState({ isSent: true }));
    };

    render() {
      return (
        <AuthUserContext.Consumer>
          {(authUser) =>
          
          authUser && authUser.hasOwnProperty('pendingUser') && authUser.pendingUser ? (
              <div style={{ paddingTop: 75 }}>
                <p>
                 Your account is pending verification.
                </p>
              </div>
            ) : needsEmailVerification(authUser) ? (
              <div style={{ paddingTop: 75 }}>
                {this.state.isSent ? (
                  <p>
                    E-Mail confirmation sent: Check you E-Mails (Spam
                    folder included) for a confirmation E-Mail.
                    Refresh this page once you confirmed your E-Mail.
                  </p>
                ) : (
                  <p>
                    Verify your E-Mail: Check you E-Mails (Spam folder
                    included) for a confirmation E-Mail or send
                    another confirmation E-Mail.
                  </p>
                )}

                <button
                  onClick={this.onSendEmailVerification}
                  disabled={this.state.isSent}
                  style={{
                    backgroundColor: '#30302e',
                    color: '#f2ebe6',
                    paddingLeft: 15,
                  }}
                >
                  Send confirmation E-Mail
                  <img
                    style={{
                      height: 32,
                      width: 32,
                    }}
                    src={require('../../assets/fm-icons-Right_arrow.svg')}
                  />
                </button>
              </div>
            ) : (
              <Component {...this.props} />
            )
          }
        </AuthUserContext.Consumer>
      );
    }
  }

  return withFirebase(WithEmailVerification);
};

export default withEmailVerification;
